toggleButtonNav();


function toggleButtonNav() {
  const btns = [...document.querySelectorAll('#btn-ctr > button')];
  const faqs = [...document.querySelectorAll('.faq-list > *')];
  if (btns.length === 0 || faqs.length === 0) return;

  init();

  function init() {
    const mainFaqs = document.querySelector('.main-faqs');
    const minLimit = 1;
    const maxLimit = 4;
    let currentLimit = 4;
    
    setAll(true);
    handleBtnClicks();

    
    function handleBtnClicks() {
      btns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          console.log(currentLimit);

          if (btn.dataset.bid === 'all') {
            setAll(true);
            
          } else {
            const datasetVal = 'show' + btn.dataset.bid.charAt(0).toUpperCase() + btn.dataset.bid.slice(1);
            const currentDataVal = mainFaqs.dataset[`${datasetVal}`];
            console.log('init',currentLimit,currentDataVal, mainFaqs.dataset.showAll);

            if (currentLimit === 4 && mainFaqs.dataset.showAll == 'true') {
              mainFaqs.setAttribute('data-show-all', 'false');
              mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'true');

              btns.filter((tempBtn) => tempBtn.dataset.bid == 'all').forEach((tempBtn) => tempBtn.classList.remove('color-scheme-5'));
              btn.classList.add('color-scheme-5');
              currentLimit = 1;
              
            } else if (currentDataVal == 'false') {
              if (currentLimit === 3) {
                setAll(true);
              } else {
                mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'true');

                if (currentLimit === 4) {
                  currentLimit = 1;
                  mainFaqs.setAttribute('data-show-all', 'false');
                } else {
                  currentLimit++
                  btn.classList.add('color-scheme-5');
                }
              }
              
            } else if (currentDataVal == 'true' && currentLimit > 1) {
              mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'false');
              btn.classList.remove('color-scheme-5');
              currentLimit--;
            }
          }
        });
      });
    }

    function setAll(value) {
      mainFaqs.setAttribute('data-show-ship', !value);
      mainFaqs.setAttribute('data-show-order', !value);
      mainFaqs.setAttribute('data-show-custom', !value);
      mainFaqs.setAttribute('data-show-group', !value);
      mainFaqs.setAttribute('data-show-all', value);
      currentLimit = (value == true) ? 4 : 1;
      if (currentLimit === 4) {
        btns.filter((btn) => btn.dataset.bid != 'all').forEach((btn) => btn.classList.remove('color-scheme-5'));
        btns.filter((btn) => btn.dataset.bid == 'all')[0].classList.add('color-scheme-5');
      }
    }
  }
}
/* Minified 6/2/23
toggleButtonNav();


function toggleButtonNav() {
  const btns = [...document.querySelectorAll('#btn-ctr > button')];
  const faqs = [...document.querySelectorAll('.main-faqs > *')];
  if (btns.length === 0 || faqs.length === 0) return;

  init();

  function init() {
    const mainFaqs = document.querySelector('.main-faqs');
    const minLimit = 1;
    const maxLimit = 4;
    let currentLimit = 4;
    
    setAll(true);
    handleBtnClicks();

    
    function handleBtnClicks() {
      btns.forEach((btn) => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          console.log(currentLimit);

          if (btn.dataset.bid === 'all') {
            setAll(true);
            
          } else {
            const datasetVal = 'show' + btn.dataset.bid.charAt(0).toUpperCase() + btn.dataset.bid.slice(1);
            const currentDataVal = mainFaqs.dataset[`${datasetVal}`];
            console.log('init',currentLimit,currentDataVal, mainFaqs.dataset.showAll);

            if (currentLimit === 4 && mainFaqs.dataset.showAll == 'true') {
              mainFaqs.setAttribute('data-show-all', 'false');
              mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'true');
              currentLimit = 1;
              
            } else if (currentDataVal == 'false') {
              if (currentLimit === 3) {
                setAll(true);
              } else {
                mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'true');

                if (currentLimit === 4) {
                  currentLimit = 1;
                  mainFaqs.setAttribute('data-show-all', 'false');
                } else {
                  currentLimit++
                }
              }
              
            } else if (currentDataVal == 'true' && currentLimit > 1) {
              mainFaqs.setAttribute(`data-show-${btn.dataset.bid}`, 'false');
              currentLimit--;
            }
          }
        });
      });
    }

    function setAll(value) {
      mainFaqs.setAttribute('data-show-ship', !value);
      mainFaqs.setAttribute('data-show-order', !value);
      mainFaqs.setAttribute('data-show-custom', !value);
      mainFaqs.setAttribute('data-show-group', !value);
      mainFaqs.setAttribute('data-show-all', value);
      currentLimit = (value == true) ? 4 : 1;
    }
  }
}
*/
